import { createVanIconComponent } from "./van"

const CartCircleOutlined = createVanIconComponent("cart-circle-o")
export default CartCircleOutlined
